export default __webpack_public_path__ + "static/progress-bar-loading-do-75530ff40e49e048d61de28b67fbae8f.png";